<template>
  <router-view />
</template>

<script>
export default {
  name: "BookeepingMain",
};
</script>